/**
 * vue-i18n `postTranslation` hook.
 *
 * Rewrites the upstream product name in every translated string with the
 * installation name, so a white-labelled instance never shows "Chatwoot".
 * The match is case-sensitive and whole-word on purpose: identifiers such as
 * `window.chatwootSettings` and hosts such as `chatwoot.com` must stay intact.
 */
const UPSTREAM_BRAND = /\bChatwoot\b/g;

export const applyInstallationName = translated => {
  const installationName = window.globalConfig?.INSTALLATION_NAME;
  if (typeof translated !== 'string' || !installationName) return translated;

  return translated.replace(UPSTREAM_BRAND, installationName);
};
